import { render, staticRenderFns } from "./institutionalFramework.vue?vue&type=template&id=dba8bdc2&scoped=true&"
import script from "./institutionalFramework.vue?vue&type=script&lang=js&"
export * from "./institutionalFramework.vue?vue&type=script&lang=js&"
import style0 from "./institutionalFramework.vue?vue&type=style&index=0&id=dba8bdc2&prod&lang=less&"
import style1 from "./institutionalFramework.vue?vue&type=style&index=1&id=dba8bdc2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba8bdc2",
  null
  
)

export default component.exports